<div class="db-website-title">
  <div class="db-website-title-image" [ngStyle]="{backgroundImage: 'url(&quot;'+ (website?.screenshot && !website?.isLocalhost ?  'data:image/jpg;base64,' + website?.screenshot : '../../assets/images/common/no_screenshot.svg') + '&quot;)'}"></div>
  <div>
    <div>
      <h1 [innerHTML]="website?.title"></h1>
      <i class="db-icon db-icon-ds-circle-filled" *ngIf="website?.domain_hash"></i>
    </div>
    <a target="_blank" rel="noopener">{{website?.site_url}}</a>
  </div>
  <div  [ngClass]="{'toggled': sidebarIsToggled}">
<!--   dbInfoTooltipHover [dbInfoTooltipHoverPosition]="'bottom-right-wp'" [dbInfoTooltipHoverBody]="'text_wpAdminInfoDesc' | dbText" [dbInfoTooltipHoverHeader]="'text_wpAdminInfoTitle' | dbText"  -->
    <i *ngIf="userSubscription?.type === UserSubscriptionType.FREE || userSubscription?.type === UserSubscriptionType.PLATFORM"
       class="db-icon db-icon-ds-settings"></i>
    <a *ngIf="userSubscription?.type !== UserSubscriptionType.FREE && userSubscription?.type !== UserSubscriptionType.PLATFORM"
       dbWpLink [adminLink]="website?.adminUrl" [websiteId]="website?.id" target="_blank" rel="noopener" >
      <img src="assets/images/icons/wp.svg" alt=""/> </a>
  </div>
</div>
